// 下载文件方法
const download = function (file, filename) {
  const isLocal = /^data:image/.test(file)
  if (isLocal) {
    // 本地直接下载
    const eleLink = document.createElement('a')
    eleLink.download = filename
    eleLink.style.display = 'none'
    eleLink.href = file
    // 触发点击
    document.body.appendChild(eleLink)
    eleLink.click()
    // 然后移除
    document.body.removeChild(eleLink)
  } else {
    const x = new XMLHttpRequest()
    x.open('GET', file, true)
    x.responseType = 'blob'
    x.onload = function () {
      const url = window.URL.createObjectURL(x.response)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
      a.remove()
    }
    x.send()
  }
}

export default download
